import {
  getFinalDayConversion,
  getFinalHourConversion,
  getFinalMinuteConversion,
  getFinalMonthConversion,
  getFinalSecondConversion,
  getFinalWeekConversion,
  getFinalYearConversion
} from "./TimeConversionTracker";

function getConversion(val, conType) {
  let result = "";
  switch (conType.slice(0, 2)) {
    case "da":
      result = getFinalDayConversion(val, conType);
      break;
    case "hr":
      result = getFinalHourConversion(val, conType);
      break;
    case "mn":
      result = getFinalMinuteConversion(val, conType);
      break;
    case "mo":
      result = getFinalMonthConversion(val, conType);
      break;
    case "sd":
      result = getFinalSecondConversion(val, conType);
      break;
    case "wk":
      result = getFinalWeekConversion(val, conType);
      break;
    case "yr":
      result = getFinalYearConversion(val, conType);
      break;
    default:
      result = "";
  }

  return result;
}

export { getConversion };
